module.exports = __webpack_public_path__ + "static/media/AutreWeb.f069515d.png";